// ---------------------------------------------------------------------------
// DEMO: la demo SOLO usa sessionStorage. Todo lo que la app guarda en localStorage
// (sesión, respaldo del store, base de sincronización, borradores del corte, tema,
// tarjetas plegadas) se redirige aquí a sessionStorage, así cerrar la pestaña no deja
// nada en el navegador. Debe ser el PRIMER import de main.jsx: ningún módulo puede
// haber tocado localStorage antes.
//
// El check va DIRECTO a import.meta.env (no por flags.js) para que Vite lo vuelva un
// literal y en el build normal esto no haga nada.
// ---------------------------------------------------------------------------
if (import.meta.env.VITE_DEMO_MODE === 'true' && typeof window !== 'undefined') {
  try {
    window.localStorage.clear(); // restos de demos anteriores que sí usaban localStorage
    Object.defineProperty(window, 'localStorage', { value: window.sessionStorage, configurable: true });
  } catch {
    /* almacenamiento bloqueado (modo privado estricto): la demo sigue en memoria */
  }
}
